"use client";

import { useEffect } from "react";
import LogRocket from "logrocket";
import useCurrentUser from "@/hooks/use-current-user";

// No `!` here: if the env var isn't set in the build this is genuinely
// undefined, and LogRocket.init(undefined) throws "must pass a valid
// application id". Because this provider mounts in the root layout, that throw
// escalates to the global error boundary ("Something went wrong") — it surfaced
// in the installed PWA, where the cached SDK makes init throw synchronously
// inside the effect. Guard + try/catch so LogRocket can never crash the app.
const LOGROCKET_APP_ID = process.env.NEXT_PUBLIC_LOGROCKET_APP_ID;
const LOGROCKET_ENABLED =
  process.env.NODE_ENV === "production" && !!LOGROCKET_APP_ID;

const LogRocketProvider = () => {
  useEffect(() => {
    if (typeof window === "undefined" || !LOGROCKET_ENABLED) return;
    try {
      LogRocket.init(LOGROCKET_APP_ID!);
    } catch (e) {
      console.error("LogRocket init failed:", e);
    }
  }, []);

  return null;
};

export default LogRocketProvider;

export function LogRocketIdentify() {
  const { user } = useCurrentUser();

  useEffect(() => {
    if (!user || !LOGROCKET_ENABLED) return;
    try {
      LogRocket.identify(user._id, {
        name: user.name,
        email: user.email,
        role: user.role,
      });
    } catch (e) {
      console.error("LogRocket identify failed:", e);
    }
  }, [user]);

  return <></>;
}
